module.exports = __webpack_public_path__ + "img/C-back.5eaaff5c.png";